export { default } from './RibbonFirstTwo'
